@if (!customerContactList || customerContactList.length === 0) {
	<p>There's no contact record in this customer.</p>
	<p>Add a contact?</p>
	@if (sharedService.isAdmin() == false && sharedService.isBossAccount() == false && !sharedService.isFinance()) {
		<button class="btn btn-dark" (click)="openAddContactModal()">Add Contact</button>
	}
} @else {
	<div class="d-flex align-items-end justify-content-end p-1">
		@if (sharedService.isAdmin() == false && sharedService.isBossAccount() == false && !sharedService.isFinance() && sharedService.isAuditor() == false) {
			<button class="btn btn-dark" (click)="openAddContactModal()">Add Contact</button>
		}
	</div>
	@for (contact of customerContactList; track contact; let i = $index) {
		<div class="card shadow-lg m-2">
			<div class="row">
				<div class="col-1 d-flex justify-content-center align-items-center">
					<img src="../../../assets/image/contactAvatar.png" class="rounded-circle" style="max-width: 50px; max-height: 50px" />
				</div>
				<div class="col-11">
					<div class="row p-2">
						<div class="col-12">
							<div class="row">
								<div class="col-7">
									<h4 class="fw-bold text-primary">
										{{ contact.Name }}
										@if (contact.ICNumber != undefined) {
											<span> | {{ sharedService.processICNum(contact.ICNumber) }} </span>
										}
									</h4>
								</div>
								<div class="col-5">
									@if (sharedService.isBranchAccountHandler() || sharedService.isBossAccount()) {
										<button class="btn btn-warning" (click)="openEditContactModal(contact)" #tooltip="matTooltip" matTooltip="Edit" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black"><i class="fas fa-pencil-alt"></i></button>
									}
									@if (this.sharedService.isBranchAccountHandler()) {
										<button class="btn btn-danger" (click)="confirmBeforeDelete(contact)" #tooltip="matTooltip" matTooltip="Delete" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black">
											<i class="fas fa-trash-alt"></i>
										</button>
									}
									<button class="btn btn-info ms-1" (click)="downloadGuarantorForm(contact)" #tooltip="matTooltip" matTooltip="Print Guarantor Form" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black">
										<i class="fas fa-print"></i>
									</button>
									<div class="dropdown d-inline ms-1" #tooltip="matTooltip" matTooltip="Upload Contact Files" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black">
										@if (sharedService.isAdmin() == false && sharedService.isBossAccount() == false && !sharedService.isFinance() && sharedService.isAuditor() == false) {
											<button class="btn btn-dark dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
												<i class="fas fa-upload"></i>
											</button>
										}
										<div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
											<a class="dropdown-item" (click)="openUploadImageModal(contact, this.enums.CONTACT_GUARANTOR_FORM)"> <i class="fas fa-signature"></i> Guarantor Form</a>
											<a class="dropdown-item" (click)="openUploadImageModal(contact, this.enums.CONTACT_PROOF_OF_RELATION)"> <i class="far fa-heart"></i> Proof Of Relation</a>
											<a class="dropdown-item" (click)="openUploadImageModal(contact, this.enums.CONTACT_ACKNOWLEDGEMENT)"> <i class="fas fa-clipboard-check"></i> Acknowledgement</a>
											<a class="dropdown-item" (click)="openUploadImageModal(contact, this.enums.CONTACT_PHOTO)"> <i class="fas fa-photo-video"></i> Other Docs</a>
										</div>
									</div>
									@if (contact.GuarantorFilename != undefined) {
										<button class="btn btn-primary ms-1" #tooltip="matTooltip" matTooltip="Download Guarantor Form" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black" (click)="downloadFile(contact.GuarantorFilename, viewCustomer.ID)">
											<i class="fas fa-download"></i>
										</button>
									}
									<button class="btn btn-primary ms-1" #tooltip="matTooltip" matTooltip="View Contact Docs" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black" (click)="openViewContactDocsModal(contact.ID)">
										<i class="far fa-folder-open"></i>
									</button>
									<button class="btn btn-outline-dark ms-1" #tooltip="matTooltip" matTooltip="View Signing History" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black" (click)="openViewDocusealHistory(contact.ID)">
										<i class="fas fa-history"></i>
									</button>
								</div>
							</div>
						</div>
						<div class="col-12"><i class="fas fa-phone"></i> {{ contact.ContactNumber }}</div>
						<div class="col-12"><i class="fas fa-users"></i> {{ contact.Relation }}</div>
						<div class="col-12"><i class="fas fa-address-book"></i> {{ contact.Address }}</div>
					</div>
				</div>
			</div>
		</div>
	}
}
